import React, { Component, Suspense } from 'react';
import './Plan.sass';
import Config from '../../../base/config/Config';
import Utils from '../../../base/Utils';
import Button from './../../component/button/Button';
import Title from '../../component/title/Title';
import Message from '../../component/message/Message';
import SmallText from '../../component/smallText/Smalltext';
import ToggleButton from '../../component/toggleButton/ToggleButton';
import Switch from '../../component/switch/Switch';
import PricingBox, { PricingBoxPriceCategory } from '../../component/pricingBox/PricingBox';
import emoji from '../../../resources/icons/1f6091.webp';
import i18n from '../../../i18n';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import DataArray from '../../../base/config/DataArray';
import LazyLoad from 'react-lazyload';

class Plan extends Component {

    defaultState = { activeToggle: 'Right', activeSwitch: true, hasLoadedPlans: false };

    constructor(props) {
        super(props);
        this.state = this.defaultState;
    }

    componentDidMount() {
        this.setState({ activeToggle: 'Right' });
    }

    handleToggle = (activeToggle) => {
        this.setState({ activeToggle: activeToggle });
    }

    handleSwitch = (activeSwitch) => {
        this.setState({ activeSwitch: activeSwitch });
    }

    handleRegister = (plan) => {
        var frequency = (this.state.activeSwitch ? 'Yearly' : 'Monthly');

        window.top.location = `${Config.appHost}register?` + Utils.generatePlanRegisterData(plan, frequency) + '&utm_source=website&utm_medium=homepage&utm_campaign=cta-4-pricing';

    }

    render() {
        var currentLanguage = Cookies.get('currentLanguage');

        var dataArray = DataArray.plans;
        var leftTextSwitch = '';
        var rightTextSwitch = '';

        if (this.state.activeSwitch === false) {
            leftTextSwitch = 'Secundary';
            rightTextSwitch = 'Seventh';
        }
        else {
            leftTextSwitch = 'Seventh';
            rightTextSwitch = 'Secundary';
        }

        var currencyCode = '';
        if (Utils.isset(this.props.planPrices.currencyCode)) {
            currencyCode = this.props.planPrices.currencyCode;
        }

        var removeToggle = false;
        if (Utils.isset(this.props.planPrices.planPrices, {})['Starter'] && !this.props.planPrices.planPrices['Starter'].price) {
            removeToggle = true;
        }

        return (
            <Suspense fallback={null}>
                <div className="PlanArea">
                    <div className="PlanMessageArea">
                        <Title size="Big" type="Secundary" text={i18n.t('We have the perfect plan for you')} />
                    </div>
                    {!removeToggle && <div className={'PlanToggleArea' + (!this.state.hasLoadedPlans ? ' loadingArea' : '')}>
                        <ToggleButton leftText={i18n.t('BASIC')} rightText={i18n.t('ADVANCED')} onSelectActive={this.handleToggle} />
                    </div>}
                    <div className={'PlanSwitchArea' + (!this.state.hasLoadedPlans ? ' loadingArea' : '')}>
                        <div className="PlanSwitch">
                            <div className="PlanSwitchLeftTextArea">
                                <SmallText size="Bigger" font="OpenSans" type={leftTextSwitch} text={i18n.t('Monthly Payment')} />
                            </div>
                            <Switch onSelectActive={this.handleSwitch} />
                            <div className="PlanSwitchRightTextArea">
                                <SmallText size="Bigger" font="OpenSans" type={rightTextSwitch} text={i18n.t('Yearly Payment')} />
                                <SmallText size="Bigger" font="OpenSansItalic" type="Tertiary" text={i18n.t('Save 15% with yearly payments')} />
                            </div>
                        </div>
                    </div>
                    <div className={'PricingBoxPlanArea' + (!this.state.hasLoadedPlans ? ' loadingArea' : '')}>
                        {dataArray.map((plan, key) => {
                            var priceText = '';
                            var monthText = '';
                            var billingText = '';

                            var priceCategory = plan.priceCategories;

                            var currencyTemplate = '';
                            var planPricing = null;
                            if (typeof this.props.planPrices != 'undefined') {
                                if (Object.keys(this.props.planPrices).length > 0 &&
                                    typeof this.props.planPrices.currencyTemplate != 'undefined') {
                                    if (this.state.hasLoadedPlans === false) {
                                        this.setState({ hasLoadedPlans: true });
                                    }
                                    currencyTemplate = this.props.planPrices.currencyTemplate;
                                }

                                if (Object.keys(this.props.planPrices).length > 0 &&
                                    typeof this.props.planPrices.planPrices != 'undefined' &&
                                    typeof this.props.planPrices.planPrices[plan.title] != 'undefined') {
                                    planPricing = this.props.planPrices.planPrices[plan.title];
                                }
                            }

                            if (planPricing !== null && typeof planPricing.price !== 'undefined') {
                                priceText = Utils.calculatePlanPrice(planPricing, this.state.activeSwitch);
                                priceText = currencyTemplate.replace('%default%', priceText);
                            }

                            monthText = plan.textMonthly;

                            if (this.state.activeSwitch === false) {
                                billingText = plan.billedMonthly;
                            } else {
                                billingText = plan.billedYearly;
                            }

                            if (plan.toggleType === this.state.activeToggle && (priceText.length > 0 || !this.state.hasLoadedPlans)) {
                                return (
                                    <div className='PricingBox' key={key}>
                                        <PricingBox mostSubscribed={plan.mostSubscribed} iconSrc={plan.icon} titleText={plan.title} priceText={<div dangerouslySetInnerHTML={{ __html: priceText }} />} loading={!this.state.hasLoadedPlans} monthText={monthText} billingText={billingText} topButtonText={i18n.t('I Want to Start now')} bottomButtonText={i18n.t('More Details')} type={plan.type} hrefTopButton={() => this.handleRegister(plan.Title)} hrefbottomButton={`${Config.host}${currentLanguage}/pricing#comparePrice`} >
                                            {priceCategory.map((priceCategory, key) => {
                                                var text = Utils.clone(priceCategory.categoryText);
                                                if (text.includes(i18n.t('Mentions')) || text.includes(i18n.t('ANDIE Credits')))
                                                    if (typeof priceText !== 'undefined' && priceText.includes('R$')) {
                                                        var covertText = Utils.clone(priceCategory.categoryText);
                                                        var startText = covertText.indexOf('|') + 1;
                                                        var endText = covertText.indexOf('|', startText);
                                                        var text_to_get = covertText.substring(startText, endText);
                                                        var dividedValue = parseInt(text_to_get);
                                                        dividedValue /= 2;

                                                        text = Utils.clone(covertText.replace(`|${text_to_get}|`, `|${Math.ceil(dividedValue)}|`));
                                                    }
                                                return (
                                                    <PricingBoxPriceCategory isNew={priceCategory.isNew} categoryText={text} categoryType={plan.type} key={key} />
                                                );
                                            })}
                                        </PricingBox>
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                    <div className="PlanMessage">
                        <div>
                            <SmallText type='Secundary' size="Big" font="SofiaProItalic" text={i18n.t('All prices in {{currency}} without VAT.', { currency: currencyCode })} />
                            <SmallText type='Secundary' size="Big" font="SofiaProRegular" text={'‏‏‎ ‎' + i18n.t('Payments accepted with Credit Cards (Visa Card, MasterCard and others).')} />
                        </div>
                        <div className="PlanEmojiMessage">
                            <Title size="Small" type="Tertiary" text={i18n.t('14-day free trial included, we won\'t charge you during this time, trust us')} />
                            <div className="PlanMessageImage" >
                                <LazyLoad offset={200} height={40}>
                                    <img alt="planEmoji" src={emoji} />
                                </LazyLoad>
                            </div>
                        </div>
                    </div>
                    <div className="PlanBoxArea">
                        <div className="PlanBoxTitle">
                            <Title size="Small" type="Secundary" text={i18n.t('We didn’t fit you?')} />
                            <div className="PlanBoxMessage">
                                <Message size="Medium" type="PlanBox" text={i18n.t('Here’s the magic button to contact us and tell us your needs and we will give the best offer, specially for you.')} />
                            </div>
                        </div>
                        <div className="PlanBoxButton">
                            <Link to={`/${currentLanguage}/contact`} > <Button size="Medium" type="Primary" text={i18n.t('Contact Us')} /> </Link>
                        </div>
                    </div>
                </div>
            </Suspense>
        );
    }
}

export default Plan;
